var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("h1", { staticClass: "page-title" }, [_vm._v("Advocacy Setting")]),
          _c("breadcrumb", { attrs: { name: "ADVOCACY_LIST" } }),
          _c("div", { staticClass: "page-header-actions" }, [
            _vm.activeTab === "characters"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-round btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.createCharacter },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-plus",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" Create "),
                  ]
                )
              : _vm.activeTab === "questions" && !_vm.isQuestionEditing
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-round btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.createQuestion },
                  },
                  [
                    _c("i", {
                      staticClass: "icon md-plus",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" Create "),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "page-content page-content-table" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "panel" }, [
            _c("nav", { staticClass: "nav nav-pills nav-fill" }, [
              _c(
                "a",
                {
                  class: _vm.tabClass("skus"),
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "skus"
                    },
                  },
                },
                [_vm._v(" SKUs ")]
              ),
              _c(
                "a",
                {
                  class: _vm.tabClass("characters"),
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "characters"
                    },
                  },
                },
                [_vm._v(" Characters ")]
              ),
              _c(
                "a",
                {
                  class: _vm.tabClass("questions"),
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "questions"
                    },
                  },
                },
                [_vm._v(" Question Pool ")]
              ),
            ]),
            _c("div", { staticClass: "panel-body p-0" }, [
              _vm.activeTab === "skus"
                ? _c("div", { staticClass: "page-content container-fluid" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12 col-xl-12" }, [
                        _c("table", { staticClass: "table" }, [
                          _vm._m(0),
                          _c(
                            "tbody",
                            _vm._l(_vm.skus, function (sku, index) {
                              return _c("tr", { key: sku.id || index }, [
                                _c("th", { staticClass: "t1" }, [
                                  _vm._v("No." + _vm._s(index + 1)),
                                ]),
                                _c("th", { staticClass: "t2" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.skus[index].status,
                                          expression: "skus[index].status",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.skus[index],
                                              "status",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function ($event) {
                                            return _vm.submitSku(
                                              "status",
                                              _vm.skus[index].id,
                                              index
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "active",
                                            disabled:
                                              _vm.skus[index].status ==
                                              "active",
                                            hidden:
                                              _vm.skus[index].status ==
                                              "active",
                                          },
                                        },
                                        [_vm._v(" ACTIVE ")]
                                      ),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "inactive",
                                            disabled:
                                              _vm.skus[index].status ==
                                              "inactive",
                                            hidden:
                                              _vm.skus[index].status ==
                                              "inactive",
                                          },
                                        },
                                        [_vm._v(" INACTIVE ")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("th", { staticClass: "t3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.skus[index].label,
                                        expression: "skus[index].label",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text", maxlength: "50" },
                                    domProps: { value: _vm.skus[index].label },
                                    on: {
                                      change: function ($event) {
                                        return _vm.submitSku(
                                          "label",
                                          _vm.skus[index].id,
                                          index
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.skus[index],
                                          "label",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c("th", { staticClass: "t4" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.skus[index].description,
                                        expression: "skus[index].description",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text", maxlength: "255" },
                                    domProps: {
                                      value: _vm.skus[index].description,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.submitSku(
                                          "description",
                                          _vm.skus[index].id,
                                          index
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.skus[index],
                                          "description",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c("th", { staticClass: "t5" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.skus[index].thumbnail,
                                      alt: "SKU thumbnail",
                                    },
                                  }),
                                ]),
                                _c("th", { staticClass: "t6" }, [
                                  _c("input", {
                                    ref: "fileUpload" + _vm.skus[index].id,
                                    refInFor: true,
                                    staticStyle: { display: "none" },
                                    attrs: { type: "file", accept: "image/*" },
                                    on: { change: _vm.onSkuFileSelected },
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-round btn-default mx-10",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.displayRef(
                                            "fileUpload" + _vm.skus[index].id,
                                            _vm.skus[index].id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-file-text-o",
                                        staticStyle: { "font-size": "18px" },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("th", { staticClass: "t7" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-round btn-default mx-10",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeSku(
                                            _vm.skus[index].id,
                                            _vm.skus[index].image
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash-o",
                                        staticStyle: { "font-size": "18px" },
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-round btn-default mx-10",
                            attrs: { type: "button" },
                            on: { click: _vm.addSku },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Add "),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm.activeTab === "characters"
                ? _c(
                    "div",
                    { staticClass: "page-content container-fluid" },
                    [
                      _c("div", { staticClass: "row mb-20" }, [
                        _c("div", { staticClass: "col-md-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.characterKeyword,
                                expression: "characterKeyword",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder:
                                "Search Char Name or Char Description",
                            },
                            domProps: { value: _vm.characterKeyword },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.characterKeyword =
                                  $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("vue-good-table", {
                        attrs: {
                          columns: _vm.characterColumns,
                          rows: _vm.filteredCharacters,
                          "pagination-options": {
                            enabled: true,
                            mode: "records",
                          },
                        },
                        on: { "on-row-click": _vm.openCharacterDetail },
                        scopedSlots: _vm._u([
                          {
                            key: "table-row",
                            fn: function (props) {
                              return [
                                props.column.field === "image_url"
                                  ? _c("span", [
                                      props.row.image_url
                                        ? _c("img", {
                                            staticClass:
                                              "imageTable imageTable--large",
                                            attrs: {
                                              src: props.row.image_url,
                                              alt: "Character thumbnail",
                                            },
                                          })
                                        : _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("n/a")]
                                          ),
                                    ])
                                  : props.column.field === "background_url"
                                  ? _c("span", [
                                      props.row.background_url
                                        ? _c("img", {
                                            staticClass:
                                              "imageTable imageTable--large",
                                            attrs: {
                                              src: props.row.background_url,
                                              alt: "Character background",
                                            },
                                          })
                                        : _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("n/a")]
                                          ),
                                    ])
                                  : props.column.field === "modified_time"
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(
                                              props.row.modified_time
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ] || "n/a"
                                          ) +
                                          " "
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "page-content container-fluid" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12 col-xl-12" }, [
                        _vm.isQuestionEditing
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "panel panel-bordered" },
                                [
                                  _c("div", { staticClass: "panel-heading" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-row align-items-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group col-md-6 mb-0",
                                          },
                                          [
                                            _c("h3", [
                                              _vm._v(
                                                " Question - " +
                                                  _vm._s(_vm.questionForm.id) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.questionForm.name || ""
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group col-md-6 mb-0 text-right",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-round dropdown-toggle",
                                                    staticStyle: {
                                                      "text-transform":
                                                        "uppercase",
                                                    },
                                                    attrs: {
                                                      type: "button",
                                                      "data-toggle": "dropdown",
                                                      "aria-expanded": "false",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.questionForm
                                                            .status
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdown-menu",
                                                    attrs: { role: "menu" },
                                                  },
                                                  [
                                                    _vm.questionForm.status ==
                                                    "active"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            attrs: {
                                                              href: "javascript:void(0)",
                                                              role: "menuitem",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.submitQuestionStatus(
                                                                  "inactive"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Inactive ")]
                                                        )
                                                      : _vm._e(),
                                                    _vm.questionForm.status ==
                                                    "inactive"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            attrs: {
                                                              href: "javascript:void(0)",
                                                              role: "menuitem",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.submitQuestionStatus(
                                                                  "active"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Active ")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-round btn-default mx-15",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click:
                                                        _vm.closeQuestionEditor,
                                                    },
                                                  },
                                                  [_vm._v(" Back to List ")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c("form", { staticClass: "form-horizontal" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group row align-items-center",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-2 col-form-control-label",
                                      },
                                      [_vm._v(" Question Name ")]
                                    ),
                                    _c("div", { staticClass: "col-sm-5" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.questionForm.name,
                                            expression: "questionForm.name",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          maxlength: "50",
                                        },
                                        domProps: {
                                          value: _vm.questionForm.name,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.submitQuestionField(
                                              "name"
                                            )
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.questionForm,
                                              "name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-2 col-form-control-label question-points-label",
                                      },
                                      [_vm._v(" Question Points ")]
                                    ),
                                    _c("div", { staticClass: "col-sm-2" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: _vm.questionForm.points,
                                            expression: "questionForm.points",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass:
                                          "form-control question-points-input",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          max: "10000",
                                        },
                                        domProps: {
                                          value: _vm.questionForm.points,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.submitQuestionField(
                                              "points"
                                            )
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.questionForm,
                                              "points",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "col-sm-2 col-form-control-label",
                                    },
                                    [_vm._v(" Question Text ")]
                                  ),
                                  _c("div", { staticClass: "col-sm-6" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.questionForm.text,
                                          expression: "questionForm.text",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text", maxlength: "64" },
                                      domProps: {
                                        value: _vm.questionForm.text,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.submitQuestionField("text")
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.questionForm,
                                            "text",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group row align-items-start",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-2 col-form-control-label",
                                      },
                                      [_vm._v(" Character ")]
                                    ),
                                    _c("div", { staticClass: "col-sm-6" }, [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questionForm.character_id,
                                              expression:
                                                "questionForm.character_id",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.questionForm,
                                                  "character_id",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                              function ($event) {
                                                return _vm.submitQuestionField(
                                                  "character_id"
                                                )
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v(" Please choose.... ")]
                                          ),
                                          _vm._l(
                                            _vm.characters,
                                            function (character) {
                                              return _c(
                                                "option",
                                                {
                                                  key: character.id,
                                                  domProps: {
                                                    value: character.id,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        character.name ||
                                                          "Character " +
                                                            character.id
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "col-sm-2 col-form-control-label",
                                    },
                                    [_vm._v(" Char Picture ")]
                                  ),
                                  _c("div", { staticClass: "col-sm-6" }, [
                                    _vm.selectedQuestionCharacter &&
                                    _vm.selectedQuestionCharacter.image_url
                                      ? _c("img", {
                                          staticClass: "preview",
                                          attrs: {
                                            src: _vm.selectedQuestionCharacter
                                              .image_url,
                                            alt: "Character preview",
                                          },
                                        })
                                      : _c(
                                          "div",
                                          { staticClass: "text-muted py-10" },
                                          [_vm._v("No image")]
                                        ),
                                  ]),
                                ]),
                                _c("table", { staticClass: "table" }, [
                                  _vm._m(1),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.questionChoices,
                                      function (choice) {
                                        return _c("tr", { key: choice.key }, [
                                          _c("th", { staticClass: "t1" }, [
                                            _vm._v("No." + _vm._s(choice.key)),
                                          ]),
                                          _c("th", { staticClass: "t2" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group row mb-0",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "col-sm-2 col-form-control-label",
                                                  },
                                                  [_vm._v(" SKU: ")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-sm-8" },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              choice.value
                                                                .sku_id,
                                                            expression:
                                                              "choice.value.sku_id",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.$set(
                                                                choice.value,
                                                                "sku_id",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function ($event) {
                                                              return _vm.submitQuestionChoice(
                                                                choice.key
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: null,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Please choose...."
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._l(
                                                          _vm.skus,
                                                          function (sku) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key: sku.id,
                                                                attrs: {
                                                                  disabled:
                                                                    sku.status ==
                                                                    "inactive",
                                                                  hidden:
                                                                    sku.status ==
                                                                    "inactive",
                                                                },
                                                                domProps: {
                                                                  value: sku.id,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      sku.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("th", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("toUpperCase")(
                                                    _vm.showSku(
                                                      choice.value.sku_id,
                                                      "status"
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("th", [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.showSku(
                                                  choice.value.sku_id,
                                                  "thumbnail"
                                                ),
                                                alt: "SKU thumbnail",
                                              },
                                            }),
                                          ]),
                                          _c("th", [
                                            _c(
                                              "div",
                                              { staticClass: "center" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        choice.value
                                                          .correct_answer,
                                                      expression:
                                                        "choice.value.correct_answer",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    "true-value": 1,
                                                    "false-value": 0,
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      choice.value
                                                        .correct_answer
                                                    )
                                                      ? _vm._i(
                                                          choice.value
                                                            .correct_answer,
                                                          null
                                                        ) > -1
                                                      : _vm._q(
                                                          choice.value
                                                            .correct_answer,
                                                          1
                                                        ),
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$a =
                                                            choice.value
                                                              .correct_answer,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? 1
                                                            : 0
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                choice.value,
                                                                "correct_answer",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                choice.value,
                                                                "correct_answer",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            choice.value,
                                                            "correct_answer",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                      function ($event) {
                                                        return _vm.submitQuestionChoice(
                                                          choice.key
                                                        )
                                                      },
                                                    ],
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                          _c("th", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-round btn-default mx-10",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteQuestionChoice(
                                                      choice.key
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-trash-o",
                                                  staticStyle: {
                                                    "font-size": "18px",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ])
                          : _c(
                              "div",
                              [
                                _c("vue-good-table", {
                                  attrs: {
                                    columns: _vm.questionColumns,
                                    rows: _vm.questionRows,
                                    "search-options": { enabled: true },
                                    "pagination-options": {
                                      enabled: true,
                                      mode: "records",
                                    },
                                  },
                                  on: {
                                    "on-row-click": _vm.openQuestionEditor,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "table-row",
                                      fn: function (props) {
                                        return [
                                          props.column.field == "thumbnail"
                                            ? _c("span", [
                                                props.row.thumbnail
                                                  ? _c("img", {
                                                      staticClass: "imageTable",
                                                      attrs: {
                                                        src: props.row
                                                          .thumbnail,
                                                        alt: "Character thumbnail",
                                                      },
                                                    })
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [_vm._v("n/a")]
                                                    ),
                                              ])
                                            : props.column.field == "status"
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("toUpperCase")(
                                                        props.row.status
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : props.column.field ==
                                              "modified_time"
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        props.row.modified_time
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.formattedRow[
                                                        props.column.field
                                                      ] || "n/a"
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                      ]),
                    ]),
                  ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "modal",
        { attrs: { name: "confrim-modal", width: 600, height: "auto" } },
        [
          _c("ConfrimModal", {
            attrs: { idSkus: _vm.removeSkuId, image: _vm.removeSkuImage },
            on: { sucessRemove: _vm.fetchSkus },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "t1", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t2", attrs: { scope: "col" } }, [
          _vm._v("Status"),
        ]),
        _c("th", { staticClass: "t3", attrs: { scope: "col" } }, [
          _vm._v("Label:"),
        ]),
        _c("th", { staticClass: "t4", attrs: { scope: "col" } }, [
          _vm._v("Description"),
        ]),
        _c("th", { staticClass: "t5", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t6", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t7", attrs: { scope: "col" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "t1-e", attrs: { scope: "col" } }, [
          _vm._v("Choices"),
        ]),
        _c("th", { staticClass: "t2-e", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t3-e", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t4-e", attrs: { scope: "col" } }),
        _c("th", { staticClass: "t5-e", attrs: { scope: "col" } }, [
          _vm._v("Correct Answer"),
        ]),
        _c("th", { staticClass: "t6-e", attrs: { scope: "col" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }